const PRELOADER_DISPLAY = async ({ commit }) => {
  commit('PRELOADER_DISPLAY');
};

const PRELOADER_HIDE = async ({ commit }) => {
  commit('PRELOADER_HIDE');
};

export default {
  PRELOADER_DISPLAY,
  PRELOADER_HIDE,
};
